<template>
  <div v-if="localShow">
    <b-progress class="loader" :max="1">
      <b-progress-bar variant="info" :value="1" stripped animated></b-progress-bar>
    </b-progress>
  </div>
</template>
<script>
export default {
  props: ['show'],
  data() {
    return {
      localShow: this.show === undefined ? true : this.show
    };
  },
  watch: {
    show(val, oldval) {
      this.localShow = val;
    }
  }
};
</script>

<style>
.loader {
  position: fixed !important;
  bottom: 0 !important;
  width: 100vw !important;
  left: 0 !important;
  z-index: 20;
}
</style>
